/**
 *
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * @Description Box component with dynamic styling for creating templates
 * @param {String} width - Defines the width of the box (required)
 * @param {Boolean} margin - Defines whether to use 1px or 2px margin (optional, default: true)
 * @param {String} borderColor - Defines the border color of the box (optional, default: '#ccc')
 * @param {String} borderRadius - Defines the border radius of the box (optional, default: '5px')
 * @returns {JSX.Element}
 */

import { Box } from '@mui/material';
import { CustomStyleTemplate } from './Styles';
import { WIDTH_SIZES } from '../enums/chartType';

const CustomBoxTemplateGraph = ({ width, margin = true }) => {

    return <Box sx={CustomStyleTemplate(margin, WIDTH_SIZES[width])}></Box>;
};
export default CustomBoxTemplateGraph;
